import React from 'react'
import env from './../../../../environments/environment'
import './NextSteps.component.scss'

const cdnImg = file =>
  `https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Fwebsite%2F${file}?alt=media`

const steps = [
  {
    number: 1,
    image: cdnImg('img.step-1.png'),
    alt: 'White number one on a red circle.',
    title: 'Talk With a Licensed Agent',
    description:
      'A licensed insurance agent takes the time to understand your needs, answer your questions, and explain things clearly\u2014at no cost to you.',
  },
  {
    number: 2,
    image: cdnImg('img.step-2.png'),
    alt: 'White number "2" in a red circle.',
    title: 'Compare Your Options',
    description:
      'We compare available plans and walk you through what each option covers, what it costs, and how it works\u2014so there are no surprises.',
  },
  {
    number: 3,
    image: cdnImg('img.step-3.png'),
    alt: 'White number 3 inside a red circle.',
    title: 'Choose Your Coverage',
    description:
      'Once you\u2019re comfortable, you choose the plan that fits your health needs, budget, and goals. We handle the details and guide you through next steps.',
  },
]

const NextSteps = () => {
  return (
    <section className='next-steps'>
      <h2 className='next-steps__heading'>
        <span>Your Path to Better Coverage</span>
      </h2>

      <div className='next-steps__grid'>
        {steps.map(step => (
          <div key={step.number} className='next-steps__step'>
            <img className='next-steps__number-img' src={step.image} alt={step.alt} width='940' height='788' />
            <h3 className='next-steps__step-title'>
              <strong>{step.title}</strong>
            </h3>
            <p className='next-steps__step-desc'>
              <span>{step.description}</span>
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default NextSteps
